// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var ReactDom = require("react-dom");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Css_Legacy_Core = require("bs-css/src/Css_Legacy_Core.bs.js");
var ReactUtils$SmartcutsMacros = require("../../../bs-utils/src/ReactUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");

function getDocumentBody(param) {
  var arg = document.querySelector("body");
  var arg$1 = (arg == null) ? undefined : Caml_option.some(arg);
  var param$1 = "Expect to find <body> element";
  return OptionUtils$SmartcutsMacros.getExn(param$1, arg$1);
}

function PlaybackModal$Loader(Props) {
  var w = Props.width;
  var duration = Props.duration;
  var bounce = Curry._1(Css.keyframes, {
        hd: [
          0,
          {
            hd: Css.left("zero"),
            tl: /* [] */0
          }
        ],
        tl: {
          hd: [
            50,
            {
              hd: Css.left({
                    NAME: "px",
                    VAL: w
                  }),
              tl: /* [] */0
            }
          ],
          tl: {
            hd: [
              100,
              {
                hd: Css.left("zero"),
                tl: /* [] */0
              }
            ],
            tl: /* [] */0
          }
        }
      });
  var dot = function (index) {
    return Curry._1(Css.style, {
                hd: Css.position("absolute"),
                tl: {
                  hd: Css.width({
                        NAME: "px",
                        VAL: 6
                      }),
                  tl: {
                    hd: Css.height({
                          NAME: "px",
                          VAL: 6
                        }),
                    tl: {
                      hd: Css.borderRadius({
                            NAME: "percent",
                            VAL: 50.0
                          }),
                      tl: {
                        hd: Css.left("zero"),
                        tl: {
                          hd: Css.top("zero"),
                          tl: {
                            hd: Css.background({
                                  NAME: "hex",
                                  VAL: "fff"
                                }),
                            tl: {
                              hd: Css.animationName(bounce),
                              tl: {
                                hd: Css.animationDuration(duration),
                                tl: {
                                  hd: Css.animationIterationCount("infinite"),
                                  tl: {
                                    hd: Css.animationDelay(Math.imul(index, duration) / 20 | 0),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              });
  };
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.height({
                          NAME: "px",
                          VAL: 24
                        }),
                    tl: {
                      hd: Css.paddingTop({
                            NAME: "px",
                            VAL: 8
                          }),
                      tl: {
                        hd: Css.selector(".path", {
                              hd: Css.margin("auto"),
                              tl: {
                                hd: Css.height({
                                      NAME: "px",
                                      VAL: 6
                                    }),
                                tl: {
                                  hd: Css.position("relative"),
                                  tl: {
                                    hd: Css.width({
                                          NAME: "px",
                                          VAL: w
                                        }),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  })
            }, React.createElement("div", {
                  className: "path"
                }, React.createElement("div", {
                      className: dot(0)
                    }), React.createElement("div", {
                      className: dot(1)
                    }), React.createElement("div", {
                      className: dot(2)
                    })));
}

var Loader = {
  make: PlaybackModal$Loader
};

var containerId = "smartcuts_playback_modal";

function PlaybackModal$PlaybackModal(Props) {
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.position("fixed"),
                    tl: {
                      hd: Css.bottom({
                            NAME: "px",
                            VAL: 20
                          }),
                      tl: {
                        hd: Css.left({
                              NAME: "vw",
                              VAL: 50.0
                            }),
                        tl: {
                          hd: Css.transform({
                                NAME: "translateX",
                                VAL: {
                                  NAME: "percent",
                                  VAL: -50.0
                                }
                              }),
                          tl: {
                            hd: Css.zIndex(20000),
                            tl: {
                              hd: Css.background({
                                    NAME: "hex",
                                    VAL: "222"
                                  }),
                              tl: {
                                hd: Css.padding2({
                                      NAME: "px",
                                      VAL: 20
                                    }, {
                                      NAME: "px",
                                      VAL: 30
                                    }),
                                tl: {
                                  hd: Css.borderRadius({
                                        NAME: "px",
                                        VAL: 8
                                      }),
                                  tl: {
                                    hd: Css.fontFamily("sansSerif"),
                                    tl: {
                                      hd: Css.boxShadow(Css_Legacy_Core.Shadow.box(undefined, undefined, {
                                                NAME: "px",
                                                VAL: 10
                                              }, {
                                                NAME: "px",
                                                VAL: 2
                                              }, undefined, {
                                                NAME: "rgba",
                                                VAL: [
                                                  0,
                                                  0,
                                                  0,
                                                  {
                                                    NAME: "percent",
                                                    VAL: 25.0
                                                  }
                                                ]
                                              })),
                                      tl: {
                                        hd: Css.selector("p, h2", {
                                              hd: Css.color({
                                                    NAME: "hex",
                                                    VAL: "fff"
                                                  }),
                                              tl: /* [] */0
                                            }),
                                        tl: {
                                          hd: Css.selector("p", {
                                                hd: Css.fontWeight("semiBold"),
                                                tl: /* [] */0
                                              }),
                                          tl: {
                                            hd: Css.selector(".actions", {
                                                  hd: Css.display("flex"),
                                                  tl: {
                                                    hd: Css.flexDirection("row"),
                                                    tl: {
                                                      hd: Css.selector("& > *", {
                                                            hd: Css.flexGrow(1.0),
                                                            tl: /* [] */0
                                                          }),
                                                      tl: {
                                                        hd: Css.selector("& > button", {
                                                              hd: Css.flexGrow(0.0),
                                                              tl: /* [] */0
                                                            }),
                                                        tl: /* [] */0
                                                      }
                                                    }
                                                  }
                                                }),
                                            tl: /* [] */0
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  })
            }, React.createElement(PlaybackModal$Loader, {
                  width: 100,
                  duration: 1500
                }), React.createElement("h2", undefined, ReactUtils$SmartcutsMacros.s("Smartcuts is operating")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("Please do not close or interact with this window while Smartcuts is operating. ")));
}

var PlaybackModal = {
  containerId: containerId,
  make: PlaybackModal$PlaybackModal
};

function render(param) {
  var container = document.createElement("div");
  container.id = containerId;
  getDocumentBody(undefined).appendChild(container);
  ReactDom.render(React.createElement(PlaybackModal$PlaybackModal, {}), container);
  
}

function remove(param) {
  Belt_Option.map(Caml_option.nullable_to_opt(document.getElementById(containerId)), (function (borderLeft) {
          return getDocumentBody(undefined).removeChild(borderLeft);
        }));
  
}

exports.Loader = Loader;
exports.PlaybackModal = PlaybackModal;
exports.render = render;
exports.remove = remove;
/* Css Not a pure module */
